import {Component, Input} from "@angular/core";

@Component({
    selector: 'tfl-filter-input',
    template: `
        <div [ngClass]="filterDivClass">
            <ng-content select="label"></ng-content>
            <ng-content select="div"></ng-content>
        </div>
    `
})
export class FilterInputComponent {

    @Input() filterDivClass: string = 'col-sm-4 col-xs-6';

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-input.component.ts